import { Select, styled } from "@mui/material";

// Operator <Select> used inside condition rows (Decision, Filter, Query
// builders). Min-width tuned so labels like "Operator" / "not equals" fit
// without truncating to "Operat..." (the legacy bug from gap-analysis.md).
export const ComparativeOperatorsSelect = styled(Select)({
	borderRadius: 8,
	background: "#FFFFFF",
	minWidth: 0,
	maxWidth: "100%",
	width: "100%",
	fontSize: 14,
	fontWeight: 500,
	"& .MuiOutlinedInput-root": {
		minWidth: 0,
		overflow: "hidden",
	},
	// Vertical padding matched to CanvasFormTextField (10/12) so the select
	// height aligns with the surrounding Field / Value text inputs and the
	// "Operator" label sits on the same baseline.
	"& .MuiSelect-select": {
		padding: "10px 32px 10px 12px",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden",
		display: "block",
		minHeight: "20px",
		minWidth: 0,
		maxWidth: "100%",
		boxSizing: "border-box",
	},
	"& .MuiSelect-icon": {
		color: "rgba(13, 31, 48, 0.55)",
		transition: "color 0.18s"
	},
	"&:hover .MuiSelect-icon": {
		color: "#02D5AB"
	},
	"& .MuiOutlinedInput-notchedOutline": {
		borderColor: "rgba(13, 31, 48, 0.14)"
	},
	"&:hover .MuiOutlinedInput-notchedOutline": {
		borderColor: "rgba(2, 213, 171, 0.5)"
	},
	"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
		borderColor: "#02D5AB",
		borderWidth: 1.5
	}
});